export const AssessmentDetailsTableHeader = [
  {
    field: 'studentName',
    headerName: 'Student Name',
    width: 200,
  },
  {
    field: 'phone',
    headerName: 'Phone Number',
    width: 200,
  },
  {
    field: 'assessmentDate',
    headerName: 'Assessment date',
    width: 200,
  },
  {
    field: 'remarks',
    headerName: 'Remarks',
    width: 200,
  },
  {
    field: 'assessmentCourse',
    headerName: 'Assessment Course ',
    width: 200,
  },
  {
    field: 'assessedBy',
    headerName: 'Assessed By',
    width: 200,
  },
  {
    field: 'skillRatings',
    headerName: 'Skill Ratings',
    width: 200,
  },
  {
    field: 'isConverted',
    headerName: 'Converted',
    renderCell: (row) => (row.isConverted ? 'Success' : 'Failed'),
    width: 200,
  },
  {
    field: 'enrollmentDate',
    headerName: 'Enrollment Date',
    width: 200,
  },
  {
    field: 'enrolledCourse',
    headerName: 'Enrolled Course',
    width: 200,
  },
  {
    field: 'daysFromAssessmentToEnroll',
    headerName: 'AssessmentToEnroll',
    width: 200,
  },
];
